// Loan account Apis
global.userAddMoneyTransfer = global.API_USER_URL+'userAddMoneyTransfer/';
global.userallMoneyTransferList = global.API_USER_URL+'userallMoneyTransferList/';
global.deleteMoneyTransaction  =  global.API_USER_URL+'deleteMoneyTransaction/';
global.userEditMoneyTransfer = global.API_USER_URL+'userEditMoneyTransfer/';

global.userBankDetails = global.API_USER_URL+'userBankDetails/';
global.editBankAccountDetail =  global.API_USER_URL+'editBankAccountDetail/';
global.deleteBankAccount =  global.API_USER_URL+'deleteBankAccount/';
global.userBankTransferDetailsList =  global.API_USER_URL+'userBankTransferDetailsList/';